import { useEffect, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
import type { RefObject } from 'react';

interface Options {
  ref: RefObject<HTMLElement>;
  to: number;
  duration?: number;
  from?: number;
}

export function useCountUp({ ref, to, duration = 1.6, from = 0 }: Options): number {
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const reduce = useReducedMotion();
  const [value, setValue] = useState(reduce ? to : from);

  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setValue(to);
      return;
    }
    const controls = animate(from, to, {
      duration,
      ease: [0.2, 0.7, 0.2, 1],
      onUpdate: (v) => setValue(v),
    });
    return () => controls.stop();
  }, [inView, reduce, from, to, duration]);

  return value;
}
